import _ from 'lodash';
import { apiFetch } from './utility';

const NOTIFIER_STATUS = 'notifier/status';
const initialState = {
	notifierStatus : undefined,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case NOTIFIER_STATUS:
			return {
				...state,
				notifierStatus : action.data
			};
		default:
			return state;
	}
};

export const halt = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notifier.halt',
			params,
			dispatch,
			successMessage : `Notifier successfully halted.`,
			callback : (err) => {
				if (err) { return callback(err); }
				dispatch(getStatus({callback}));
			},
		});
	};
};

export const run = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'notifier.run',
			params,
			dispatch,
			successMessage : `Notifier successfully run.`,
			callback : (err) => {
				if (err) { return callback(err); }
				dispatch(getStatus({callback}));
			},
		});
	};
};

export const resume = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiFetch({
			method: 'notifier.resume',
			params : {},
			dispatch,
			successMessage : `Notifier successfully resumed.`,
			callback : (err) => {
				if (err) { return callback(err); }
				dispatch(getStatus({callback}));
			},
		});
	};
};

export const getStatus = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiFetch({
			method: 'notifier.status.get',
			params : {},
			dispatch,
			callback : function (err, r) {
				dispatch({
					type: NOTIFIER_STATUS,
					data : r,
				});
				callback();
			}

		});
	};
};
